module.exports = __webpack_public_path__ + "static/media/bell.f23d1320.svg";